import { render, staticRenderFns } from "./CashierItemElement.vue?vue&type=template&id=506c2cd8&scoped=true"
import script from "./CashierItemElement.vue?vue&type=script&lang=js"
export * from "./CashierItemElement.vue?vue&type=script&lang=js"
import style0 from "./CashierItemElement.vue?vue&type=style&index=0&id=506c2cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c2cd8",
  null
  
)

export default component.exports